import {
  AccessoriesIcon,
  FacadeIcon,
  FloorIcon,
  PitchedRoofIcon,
  RoofTerraceIcon,
} from "~/components/svg/supports-categories";
import { Card } from "~/components/ui/cards/card";
import { Image } from "~/components/ui/image";
import { Text } from "~/components/ui/typography";
import { cn } from "~/utils/classnames";

import "./SupportCard.css";
import type { SupportCardProps } from "./SupportCard.types";

/**
 * Composant carte de support ou de catégorie de support
 */
export const SupportCard = ({
  title = "Toiture inclinée",
  category,
  image,
  flat = false,
  onClick,
  isActive = false,
  className,
  ...props
}: SupportCardProps) => {
  const CategorySvg = ({ className }: { className: string }) => {
    if (category === "toit-incline") {
      return <PitchedRoofIcon className={className} />;
    }
    if (category === "toit-terrasse") {
      return <RoofTerraceIcon className={className} />;
    }
    if (category === "facade") {
      return <FacadeIcon className={className} />;
    }
    if (category === "sol") {
      return <FloorIcon className={className} />;
    }
    if (category === "accessoires") {
      return <AccessoriesIcon className={className} />;
    }
    return null;
  };

  const Tag = onClick ? "button" : "div";
  return (
    <Tag onClick={onClick} {...props}>
      <Card
        className={cn(
          "relative flex flex-col items-center justify-center gap-3 p-3",
          flat && "border-none bg-transparent shadow-none",
          isActive ? "shadow-md" : ""
        )}
      >
        {category ? (
          <CategorySvg className="h-20 w-32 rounded-lg px-2" />
        ) : (
          <Image src={image || ""} alt={title} className="h-20 w-32 rounded-lg" />
        )}
        {title ? (
          <Text as="p" size="sm" className="font-medium">
            {title}
          </Text>
        ) : null}
      </Card>
    </Tag>
  );
};
